<template>
  <v-card width="100%">
    <v-card-title>{{ $t('PROGRAM.google_calendar_card.title') }}</v-card-title>
    <v-card-text>
      {{ $t('PROGRAM.google_calendar_card.description_before') }}
      <strong class="event-title">
        {{ event ? event.content[$i18n.locale].title : '' }}
      </strong>
      {{ $t('PROGRAM.google_calendar_card.description_after') }}
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="grey darken-1"
        text
        @click="dismiss()"
        class="ml-2 mb-3"
      >
        {{ $t('PROGRAM.google_calendar_card.dismiss_button') }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        dark
        color="blue darken-1"
        @click="confirm()"
        class="mr-4 mb-3"
      >
        {{ $t('PROGRAM.google_calendar_card.confirm_button') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "GoogleCalendarCard",
    props: {
      event: {
        type: Object,
        require: false,
        default: null
      }
    },
    methods: {
      dismiss() {
        this.$emit('dismiss', this.event);
      },
      confirm() {
        this.$emit('confirm', this.event);
      }
    }
  }
</script>

<style scoped>
  .event-title {
    color: #1E88E5;
  }
</style>